import secRegisteredImg from '@assets/images/sec-registered.png';
import shieldCheckIcon from '@assets/images/shield-check.svg';

export default function SecRegistered() {
  return (
    <section
      aria-labelledby="sec-registered-title"
      className="bg-white px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-20"
    >
      <div
        data-aos="fade-up"
        className="relative mx-auto max-w-6xl rounded-[24px] bg-[#FFBD59] px-6 pb-8 pt-8 sm:rounded-[32px] sm:px-8 sm:pt-9 lg:rounded-[40px] lg:px-10 lg:pb-5 lg:pt-[34px]"
      >
        {/* Copy column — kept clear of the portrait from `lg` upwards */}
        <div className="lg:max-w-[calc(100%-360px)] xl:max-w-[664px]">
          {/* Headline row: shield badge + title */}
          <div className="flex items-center gap-3 lg:gap-[11px]">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[4px] bg-white/20">
              <img
                src={shieldCheckIcon}
                alt=""
                aria-hidden="true"
                className="h-7 w-7"
                width={28}
                height={28}
              />
            </span>

            <h2
              id="sec-registered-title"
              className="text-2xl font-bold leading-tight tracking-tight text-black sm:text-[28px] lg:text-[32px] lg:leading-[46.6px] lg:tracking-[-0.9px]"
            >
              We are SEC Registered!
            </h2>
          </div>

          {/* Body copy */}
          <div className="mt-4 text-sm leading-[22.8px] text-black sm:text-base lg:mt-[17px] xl:max-w-[604px]">
            <p>
              <strong className="font-bold">AeroComp</strong> is{' '}
              <strong className="font-bold">
                under Liknayan Innovations Corp.,
              </strong>{' '}
              a legally recognized entity officially registered with the
              Securities and Exchange Commission (SEC).
            </p>
            <p className="mt-[22.8px]">
              This reinforces our commitment to transparency, compliance, and
              the highest standards of professional conduct, ensuring our
              clients and partners can do business with us with absolute
              confidence.
            </p>
          </div>
        </div>

        {/*
          Portrait: flows beneath the copy on small screens, and on large screens
          anchors to the card's bottom-right, popping out above the top edge.
          The soft halo behind the subject is baked into the PNG.
        */}
        <div className="pointer-events-none relative z-10 mx-auto -mb-8 mt-6 h-[260px] w-[273px] select-none overflow-hidden sm:h-[300px] sm:w-[315px] lg:absolute lg:bottom-0 lg:right-[40px] lg:mx-0 lg:mb-0 lg:mt-0 lg:h-[280px] lg:w-[294px] xl:right-[55px] xl:h-[325px] xl:w-[341px]">
          <img
            src={secRegisteredImg}
            alt="AeroComp representative holding a verified SEC registration badge"
            loading="lazy"
            decoding="async"
            className="absolute left-[-8.8%] top-[-15.38%] h-[124.31%] w-[118.48%] max-w-none object-contain"
          />
        </div>
      </div>
    </section>
  );
}
